export default __webpack_public_path__ + "static/flag-nl-9d952ab6f1f17b38b938967b2631e6ed.svg";